/* ZdamPrawko – landing: reveal, sticky CTA, podgląd stron. Bez zależności. */
(function () {
  var root = document.getElementById('zp');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  // 1) Reveal przy scrollu
  if (hasIO && !reduce) {
    root.classList.add('zp-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.querySelectorAll('.zp-reveal').forEach(function (el) { io.observe(el); });
  }

  // 2) Sticky CTA (mobile): widoczny, gdy żaden inny przycisk zakupu nie jest na ekranie
  var sticky = root.querySelector('[data-zp-sticky]');
  if (sticky && hasIO) {
    var forms = Array.prototype.filter.call(root.querySelectorAll('[data-zp-buy]'), function (f) { return !sticky.contains(f); });
    var visible = new Set();
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? visible.add(e.target) : visible.delete(e.target); });
      var on = visible.size === 0;
      sticky.classList.toggle('is-on', on);
      sticky.inert = !on;
    }, { threshold: 0 });
    forms.forEach(function (f) { so.observe(f); });
  }

  // 3) Blokada podwójnego kliknięcia
  root.querySelectorAll('[data-zp-buy]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none'; btn.style.opacity = '.75'; }
    });
  });

  window.addEventListener('pageshow', function () {
    root.querySelectorAll('[data-zp-buy] button[type="submit"]').forEach(function (btn) {
      btn.removeAttribute('aria-busy'); btn.style.pointerEvents = ''; btn.style.opacity = '';
    });
  });

  // 4) Podgląd stron – strzałki na desktopie
  var track = root.querySelector('[data-zp-track]');
  root.querySelectorAll('[data-zp-pv]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!track) return;
      var item = track.querySelector('.zp-pv__item');
      var step = item ? item.getBoundingClientRect().width + 14 : 300;
      track.scrollBy({ left: step * 2 * Number(b.getAttribute('data-zp-pv')), behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  // 5) Płynne przewijanie do kotwic w obrębie landingu
  root.querySelectorAll('a[href^="#zp"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var t = document.querySelector(a.getAttribute('href'));
      if (!t) return;
      ev.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });
})();
